import { MenuItem } from '../../models';

/** holds items for my progress dropdown used in navbar */
export const TWO_X_LEARNING_NAV: MenuItem[] = [
  { title: 'Daily Learning Rings', link: '/learning-rings' },
];
